<template>
    <div class="col-12">
        <div class="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-2 row-cols-xl-3 row-cols-xxl-3 g-3" v-if="this.tyres.length">
            <div v-for="tyre in this.tyres" :key="tyre.id" class="col d-flex align-items-stretch">
                <tyre
                    :featured="false"
                    :tyre="tyre"
                    :basket="basket"
                    :banners="banners"
                    :home-delivery="homeDelivery"
                    :is-smr="isSmr"
                ></tyre>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-12">
                <p>No tyres found.</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['tyres', 'brand','banners', 'basket', 'homeDelivery', 'isSmr'],
        components: {	
        },
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
        },
        computed: {

        }
    }
</script>

<style lang="scss" scoped>

</style>